;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('InputCheckboxController', InputCheckboxController)

  /* @ngInject */
  function InputCheckboxController ($scope, $attrs, $timeout, UdsModalService) {
    const getUpgradeCompanyPlanDialogController = () => import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller')

    const api = {
      activate,
      _openUpgradeCompanyPlanDialog,
      getUpgradeCompanyPlanDialogController
    }

    activate()

    function activate () {
      if ($scope.pricing) {
        $scope.disabled = true
      }

      $timeout(() => {
        if ($scope.titleTooltip) {
          $attrs.$$element.find('.input-checkbox-tooltip').popup()
        }
      }, 100, false)
    }

    $scope.onChange = function (newValue) {
      if ($scope.change) {
        $scope.change({
          modelPropertyName: $scope.modelPropertyName,
          modelNewValue: newValue
        })
      }
    }

    $scope.handlePricingClick = () => {
      if ($scope.pricing) {
        api._openUpgradeCompanyPlanDialog($scope.pricingData)
      }
    }

    function _openUpgradeCompanyPlanDialog (pricingData) {
      api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
        const upgradeCompanyPlanDialog = UdsModalService.createModal({
          controller: UpgradeCompanyPlanDialogController,
          modalName: 'upgradeCompanyPlanDialog',
          data: pricingData
        })
        upgradeCompanyPlanDialog.open()
      })
    }
  }
})()
